<section class="form">
  <form [formGroup]="formTable" class="form_table" (ngSubmit)="addData()">
    <div
      class="style-input-default input_table"
      data-text="Red social *"
      [ngClass]="{ error: verificateInput('red_social') }"
    >
      <input
        type="text"
        placeholder="Red social"
        formControlName="red_social"
      />
    </div>
    <div
      class="style-input-default input_table"
      data-text="Nombre de la cuenta *"
      [ngClass]="{ error: verificateInput('nombre_cuenta') }"
    >
      <input
        type="text"
        placeholder="Nombre de la cuenta"
        formControlName="nombre_cuenta"
      />
    </div>
    <button
      *ngIf="!status"
      type="submit"
      [disabled]="formTable.invalid || submit"
    >
      <i class="fas fa-plus"></i>
    </button>
  </form>
</section>

<div class="task_content_table">
  <table mat-table #dataTable [dataSource]="dataSource" class="task_table">
    <ng-container matColumnDef="red_social">
      <th class="header-options" mat-header-cell *matHeaderCellDef>
        Red social
      </th>
      <td mat-cell *matCellDef="let element">{{ element.red_social }}</td>
    </ng-container>

    <ng-container matColumnDef="nombre_cuenta">
      <th class="header-options" mat-header-cell *matHeaderCellDef>
        Nombre de la cuenta
      </th>
      <td mat-cell *matCellDef="let element">{{ element.nombre_cuenta }}</td>
    </ng-container>

    <ng-container matColumnDef="opciones">
      <th class="header-options" mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element; let i = index">
        <div class="options">
          <button class="delete" (click)="removerCuenta(i)">
            <i class="fas fa-times"></i>
          </button>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</div>
<mat-paginator
  [pageSizeOptions]="[5, 10, 25, 50, 100]"
  [pageSize]="5"
  [showFirstLastButtons]
></mat-paginator>
